<template>
  <div class="section" style="padding: 10px 0 0 20px">
    <span style="color:red;line-height: 30px;">注意:下列组件为消息提醒，项目中将统一使用该提醒风格 (规约)</span>
    <div style="width: 500px;">
      <div style="line-height: 30px;">Alert 警告 用于页面中展示重要的提示信息。</div>
      <el-alert title="成功提示的文案" type="success" show-icon />
      <el-alert title="消息提示的文案" type="info" show-icon />
      <el-alert title="警告提示的文案" type="warning" show-icon />
      <el-alert title="错误提示的文案" type="error" show-icon />
    </div>
    <div style="margin-top: 10px;line-height: 30px;">
      消息提示
      <span style="color:red">使用建议：一般用于用户操作过程中的消息提醒(如:提醒用户必填项、需要选择表格行、提交成功、提交失败等);在屏幕中上部显示，更能引起用户的注意</span>
    </div>
    <div>
      <el-button :plain="true" @click="open2">成功</el-button>
      <el-button :plain="true" @click="open3">警告</el-button>
      <el-button :plain="true" @click="open1">消息</el-button>
      <el-button :plain="true" @click="open4">错误</el-button>
      <el-button @click="open">Confirm 确认</el-button>
      <el-button @click="open5">Alter 提醒</el-button>
    </div>
    <div style="margin-top: 10px;line-height: 30px;">
      通知
      <span style="color:red">使用建议：一般用于显示一些全局的通知信息(如：系统出错提示、请求超时、待办事务、也可做常用功能的快捷入口等);可在屏幕四个角显示，对用户视觉刺激较弱</span>
    </div>
    <div>
      <el-button plain @click="open11">成功</el-button>
      <el-button plain @click="open21">警告</el-button>
      <el-button plain @click="open31">消息</el-button>
      <el-button plain @click="open41">错误</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifyTips',
  methods: {
    open2() {
      this.$message.success({
        showClose: true,
        message: '恭喜你，这是一条成功消息'
      })
    },
    open3() {
      this.$message.warning({
        showClose: true,
        message: '警告哦，这是一条警告消息'
      })
    },
    open1() {
      this.$message({
        showClose: true,
        message: '这是一条消息提示'
      })
    },
    open4() {
      this.$message.error({
        showClose: true,
        message: '错了哦，这是一条错误消息'
      })
    },
    open() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$message.success({
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message.info({
          message: '已取消删除'
        })
      })
    },
    open5() {
      this.$alert('这是一段内容', '标题名称', {
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${action}`
          })
        }
      })
    },
    open11() {
      this.$notify({
        title: '成功',
        message: '这是一条成功的提示消息',
        type: 'success'
      })
    },
    open21() {
      this.$notify({
        title: '警告',
        message: '这是一条警告的提示消息',
        type: 'warning'
      })
    },
    open31() {
      this.$notify.info({
        title: '消息',
        message: '这是一条消息的提示消息'
      })
    },
    open41() {
      this.$notify.error({
        title: '错误',
        message: '这是一条错误的提示消息'
      })
    }
  }
}
</script>
